/** What a failed request means to an operator (design §6.10, WP-05): the cause in words and a
 *  short code for support. A failure never reads like «нет данных». Pure, no I/O. */
import { ApiError } from '@/lib/api'

export interface ErrorInfo {
  /** what happened and what to do, one or two sentences */
  cause: string
  /** what support needs: the HTTP status, or «NET» when the server was not reached */
  code: string
}

export function describeError(e: unknown): ErrorInfo {
  if (e instanceof ApiError) {
    const code = String(e.status)
    if (e.status === 401) return { cause: 'Сессия закончилась. Войдите снова — данные не потеряны.', code }
    if (e.status === 403) return { cause: 'У вашей роли нет доступа к этим данным. Доступ выдаёт владелец.', code }
    if (e.status === 404)
      return { cause: 'Сервер не знает этот адрес: админка новее сервера. Обновите страницу после выкладки.', code }
    if (e.status === 408 || e.status === 504)
      return { cause: 'Сервер не ответил вовремя. Повторите через минуту.', code }
    if (e.status === 423 || e.status === 429) return { cause: e.message, code }
    if (e.status >= 500)
      return {
        cause: `Сервер ответил ошибкой ${e.status}. Ничего не изменилось — повторите через минуту. Если ошибка не проходит, проверьте раздел «Система».`,
        code,
      }
    // 4xx with the server's own words (a validation or a business rule) — they say it best.
    return { cause: e.detail ?? e.message, code }
  }
  if (e instanceof TypeError) {
    return { cause: 'Нет связи с сервером. Проверьте подключение и повторите.', code: 'NET' }
  }
  return { cause: 'Запрос не выполнен. Повторите; если не проходит, обновите страницу.', code: 'APP' }
}
